import { render } from "./SessionsComp.vue?vue&type=template&id=e9da07e8"
import script from "./SessionsComp.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionsComp.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/cliente-embedded/components/SessionsComp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e9da07e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e9da07e8', __exports__)) {
    api.reload('e9da07e8', __exports__)
  }
  
  module.hot.accept("./SessionsComp.vue?vue&type=template&id=e9da07e8", () => {
    api.rerender('e9da07e8', render)
  })

}


export default __exports__